const syndTrigger = document.querySelector('.synd-trigger');
function waitForElm(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }
      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              resolve(document.querySelector(selector));
              observer.disconnect();
          }
      });
      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}
waitForElm('.synd-drawer').then((elm) => {
  const syndClose = document.querySelector('.synd-close');
  syndClose.addEventListener('click', function(){
    let drawer = document.querySelector('.synd-drawer');

    drawer.classList.remove('open');
  })
});
waitForElm('.ccs-cc-inline').then((elm) => {
  syndTrigger.classList.remove('hide');
});
waitForElm('#flix-std-inpage').then((elm) => {
  syndTrigger.classList.remove('hide');
});
syndTrigger.addEventListener('click', function(){
  let drawer = document.querySelector('.synd-drawer');
  drawer.classList.add('open');
});
